import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { ReferralProgramSchema } from './referral.contract'

const path = (userId: string) => `/admin/users/${encodeURIComponent(userId)}/referrals`
export function useAdminReferrals(userId: string, offset: number, enabled: boolean) {
  return useQuery({
    queryKey: ['admin-referrals', userId, offset],
    enabled,
    queryFn: async () =>
      ReferralProgramSchema.parse(await apiFetch(`${path(userId)}?limit=20&offset=${offset}`)),
    staleTime: 30000,
  })
}
export function useUpdateReferralSettings(userId: string) {
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (settings: { enabled?: boolean; percentage?: string }) =>
      ReferralProgramSchema.parse(
        await apiFetch(path(userId), { method: 'PUT', body: settings }),
      ),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: ['admin-referrals', userId] })
    },
  })
}
